import { render, staticRenderFns } from "./GuideBookPaperCrags.vue?vue&type=template&id=09db7020&scoped=true"
import script from "./GuideBookPaperCrags.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperCrags.vue?vue&type=script&lang=js"
import style0 from "./GuideBookPaperCrags.vue?vue&type=style&index=0&id=09db7020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db7020",
  null
  
)

export default component.exports